import { ContractForm } from './ContractForm';

export default ContractForm;